import { ValidatorFn, AbstractControl, Validators } from '@angular/forms';

export function minOptions(minLength: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const result = Validators.minLength(minLength)(control);
    const isValid = !result?.minlength;
    return isValid ? null : { custom: `At least ${minLength} options are <strong>required</strong>` };
  };
}
